import { slugify } from '../utils/format-text'
import { lazyLoadView } from '../utils/lazy-load-view'
import { Role } from '../utils/role'

const CoreUtils = {
  slugify,
  lazyLoadView,
  Role,
}

export default CoreUtils
